import {
  DeductionTypeCategory,
  DeductionTypeCategoryProps,
} from "../deductionTypeCategory";

interface SubTypeProps {
    id: number;
    subTypeName: string;
    subTypeKey: string;
    deductionTypeCategory?: DeductionTypeCategoryProps | null;
}

class SubType {
    private readonly _id: number;
    private readonly _subTypeName: string;
    private readonly _subTypeKey: string;
    private readonly _deductionTypeCategory: DeductionTypeCategory | null;
    
    constructor(props: SubTypeProps) {
        this._id = props.id;
        this._subTypeName = props.subTypeName;
        this._subTypeKey = props.subTypeKey;
        this._deductionTypeCategory = props.deductionTypeCategory
            ? new DeductionTypeCategory(props.deductionTypeCategory)
            : null;
    }
    
    public get id(): number {
        return this._id;
    }

    public get subTypeName(): string {
        return this._subTypeName;
    }   

    public get subTypeKey(): string {
        return this._subTypeKey;
    }

    public get deductionTypeCategory(): DeductionTypeCategory | null {
        return this._deductionTypeCategory;
    }
}

export interface AdjustmentTypeProps {
    id: number;
    typeName: string;
    typeKey: string;
    subTypes?: SubTypeProps[] | null;
}

export class AdjustmentType {
    private readonly _id: number;
    private readonly _typeName: string;
    private readonly _typeKey: string;
    private readonly _subTypes: SubType[] | null;

    constructor(props: AdjustmentTypeProps) {
        this._id = props.id;
        this._typeName = props.typeName;
        this._typeKey = props.typeKey;
        this._subTypes = props.subTypes?.map(subType => new SubType(subType)) ?? null;
    }
    
    public get id(): number {
        return this._id;
    }

    public get typeName(): string {
        return this._typeName;
    }

    public get typeKey(): string {
        return this._typeKey;
    }

    public get subTypes(): SubType[] | null {
        return this._subTypes;
    }
}
